import { gql } from '@/__generated__';

const GET_DGA_TICKET_STATE = gql(`#graphql
  query GetDgaTicketState($deviceId: ID!) {
    device(input: { id: $deviceId }) {
      id
      profile {
        name
      }
      dga {
        id 
        # El detalle es la fuente del prefill del formulario de corrección (AMARU-736). No se
        # muestra en el widget de tableros compartidos ni en las vistas de resumen: es contexto
        # operativo interno.
        ticket {
          id
          timestamp
          description
        }
      }
    }
  }
`);

export default GET_DGA_TICKET_STATE;
